import { platformSelect } from '../../utils/platformUtils'
import React, { useEffect, useState, useMemo } from 'react'
import {
    View,
    Image,
    Text,
    TouchableOpacity,
    Linking,
    Dimensions,
    PixelRatio,
} from 'react-native'
import { StoresListModel, ActivitysModel } from './models/ScheduleModel'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './StoreItemStyles'
import { getStores } from '../../db/posSchedules'
import { openDB } from '../../db/indexDB'
import { StatusTagsStores } from './StatusTagsStores'
import {
    calculateDistance,
    getDistanceWithText,
    getDistanceWithTextCal,
} from '../../components/customUtils/calculateDistance'
import { StatusTagItem } from './StatusTagsStores'
import { getLocation } from '../appBar/context/LocationContext'
import Constants from 'expo-constants'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'

// Memoizar el componente para evitar re-renders innecesarios
export const StoreItem = React.memo(
    ({
        store,
        onClickGoStore,
        route,
    }: {
        store?: StoresListModel
        onClickGoStore?: (store: StoresListModel) => void
        route?: string
    }) => {
        // console.log('🚀 ~ StoreItem ~ store:', store)
        const expoConfig = Constants.expoConfig || { slug: '' }

        const [storeDetails, setStoreDetails] = useState(store)

        const { userLat, userLng } = getLocation()

        const openMap = () => {
            const scheme = platformSelect({
                ios: 'maps://0,0?q=',
                android: 'geo:0,0?q=',
            })
            const latLng = `${store.lat},${store.lng}`
            const label = store.name ?? 'Tienda seleccionada'
            const url = platformSelect({
                ios: `${scheme}${label}@${latLng}`,
                android: `${scheme}${latLng}(${label})`,
            }) as string
            //GoogleMaps iOS  // const browser_url = 'https://www.google.de/maps/@' + store.lat + ',' + store.lng + '?q=' + label
            Linking.openURL(url)
        }

        const [iconSize, setIconSize] = useState(20)
        const fontScale = 1
        // Detectar si el tamaño de la fuente ha sido aumentado
        useEffect(() => {
            if (fontScale > 1) {
                setIconSize(24) // Cambiar iconSize si el tamaño de la fuente es más grande
            } else {
                setIconSize(20) // Valor normal
            }
        }, [])
        // console.log('🚀 ~ StoreItem ~ storeDetails:', store.last_checkout)

        const formatDate = () => {
            if (!store?.last_checkout || store.last_checkout == '0') return ''
            const date = new Date(store.last_checkout)
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            return `${day}/${month}/${year} ${hours}:${minutes}`
        }
        let date = store?.last_checkout ? formatDate() : ''
        return (
            <View style={styles.cardStore}>
                <TouchableOpacity onPress={() => onClickGoStore(store)}>
                    <View style={styles.containerInfoStore}>
                        <View style={styles.containerColumn}>
                            <View style={styles.containerRow}>
                                <MaterialCommunityIcons
                                    name='store'
                                    size={18}
                                    color={theme.colors.darkGray}
                                    style={styles.marginRight2}
                                />
                                <Text
                                    style={styles.textNameStore}
                                    numberOfLines={2}
                                    ellipsizeMode='tail'
                                >
                                    <Text>
                                        {store.code ? `${store.code} | ` : ''}
                                    </Text>
                                    {store.name ?? ''}
                                </Text>
                            </View>
                            {store.address &&
                                store.address != '' &&
                                store.address != '-' && (
                                    <Text
                                        onPress={openMap}
                                        style={styles.textAddressStoreWithGoTo}
                                        numberOfLines={2}
                                        ellipsizeMode='tail'
                                    >
                                        {store.address ?? ''}
                                    </Text>
                                )}
                            <View style={styles.containerDataStore}>
                                <Text style={{ flex: 1 }}>
                                    <Text style={styles.textDistanceStore}>
                                        {store.cluster
                                            ? `${store.cluster}  |  `
                                            : ''}
                                    </Text>
                                    {store.potencial &&
                                        store.potencial !== '' &&
                                        store.potencial !== '-' && (
                                            <Text
                                                style={styles.textDistanceStore}
                                            >{`${store.potencial}  |  `}</Text>
                                        )}
                                    {store.frequency &&
                                        store.frequency !== '' &&
                                        store.frequency !== '-' && (
                                            <Text
                                                style={styles.textDistanceStore}
                                            >{`${store.frequency}  |  `}</Text>
                                        )}
                                    {store.topstore &&
                                        store.topstore !== '' &&
                                        store.topstore !== '-' && (
                                            <Text
                                                style={styles.textDistanceStore}
                                            >{`${store.topstore}  |  `}</Text>
                                        )}
                                    {!!store.distance && store.distance !== 0 && (
                                        <>
                                            <Text style={styles.textAddressStore}>
                                                {route ? `${route}  |  ` : ''}
                                            </Text>
                                            <Text
                                                style={styles.textAddressStore}
                                                numberOfLines={2}
                                                ellipsizeMode='tail'
                                            >
                                                {store.segment
                                                    ? `${store.segment}  |  `
                                                    : ''}
                                            </Text>
                                            <Feather
                                                name='map-pin'
                                                size={14}
                                                color={theme.colors.textSecondary}
                                                style={styles.marginRight}
                                            />
                                            <Text style={styles.textDistanceStore}>
                                                {' '}
                                                {getDistanceWithTextCal(
                                                    store.distance,
                                                )}
                                            </Text>
                                        </>
                                    )}
                                </Text>
                            </View>

                            {(!!store.distance && store.cluster.length >= 15) ||
                                (fontScale > 1 && (
                                    <View style={styles.containerDataStore}>
                                        <Feather
                                            name='map-pin'
                                            size={14}
                                            color={theme.colors.textSecondary}
                                            style={styles.marginRight}
                                        />
                                        <Text
                                            style={styles.textDistanceStore}
                                            numberOfLines={2}
                                            ellipsizeMode='tail'
                                        >
                                            {getDistanceWithTextCal(store.distance)}
                                        </Text>
                                    </View>
                                ))}
                            {date != '' && (
                                <Text
                                    style={[
                                        styles.textDistanceStore,
                                        { marginLeft: 0 },
                                    ]}
                                >
                                    {date}
                                </Text>
                            )}
                            <View style={styles.containerStatus}>
                                {expoConfig.slug != 'kimberly-one' && (
                                    <StatusTagsStores
                                        status={store.campaign_status ?? 0}
                                    />
                                )}
                                <SetActivitys
                                    relevant={store.forms_relevant}
                                    featured={store.forms_featured}
                                />
                            </View>
                        </View>
                        <Feather
                            name='chevron-right'
                            size={iconSize}
                            color={theme.colors.colorPrimary}
                        />
                    </View>
                </TouchableOpacity>
            </View>
        )
    },
    (prevProps, nextProps) => {
        // Solo re-renderizar si cambian estos valores específicos
        return (
            prevProps.store?._id === nextProps.store?._id &&
            prevProps.store?.campaign_status === nextProps.store?.campaign_status &&
            prevProps.route === nextProps.route
        )
    },
)

export const ActivityItem = ({ activity }: { activity: ActivitysModel }) => {
    return (
        <View
            style={[
                styles.circleTag,
                { backgroundColor: activity.hex_color ?? theme.colors.mediumGray },
            ]}
        >
            <Text style={styles.textCircleTag}>{activity.name ?? '-'}</Text>
        </View>
    )
}

export const SetActivitys = React.memo(
    ({
        relevant,
        featured,
    }: {
        relevant: ActivitysModel[]
        featured: ActivitysModel[]
    }) => {
        const activities = useMemo(() => {
            const sortIfIndexed = (list: ActivitysModel[]) => {
                const hasIndex =
                    list.length > 0 &&
                    list.every((item) => typeof item.index === 'number')
                if (hasIndex) {
                    return [...list].sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
                }
                return list
            }

            const sortedFeatured = sortIfIndexed(
                Array.isArray(featured) && featured.length > 0 ? featured : [],
            )
            const sortedRelevant = sortIfIndexed(
                Array.isArray(relevant) && relevant.length > 0 ? relevant : [],
            )

            const combined: ActivitysModel[] = [...sortedRelevant, ...sortedFeatured]

            const unique = combined.filter(
                (activity, index, self) =>
                    index === self.findIndex((a) => a.name === activity.name),
            )

            return {
                displayed: unique.slice(0, 4),
                totalCount: unique.length,
            }
        }, [relevant, featured])
        return (
            <View style={styles.containerActivityItem}>
                {activities.displayed.map((activity, index) => (
                    <ActivityItem activity={activity} key={index} />
                ))}
                {activities.totalCount > 4 && (
                    <Feather
                        name='plus'
                        size={16}
                        color={theme.colors.textPrimary}
                        style={styles.marginRightBis}
                    />
                )}
            </View>
        )
    },
)
